<template lang="pug">
  div
    | Search:
    .ml-2.d-inline-block
      .input-group
        input.form-control.form-control-sm(type='text' :value="value" @input="$emit('input',$event.target.value)" @keyup.enter="$emit('search')")
        .input-group-append
          .input-group-text
            button(type="button" @click="$emit('search')" class="btn btn-sm btn-link p-0")
              i.feather-search
</template>

<script>
export default {
  props: ['value']
}
</script>